import { jurisdictionsMobileWidget, jurisdictionsWidget } from "cle/jurisdictions_widgets"
import { creditTypesMobileWidget, creditTypesWidget } from "cle/credit_types_widgets"
import { practiceAreasMobileWidget, practiceAreasWidget } from "cle/practice_areas_widgets"
import { presentersMobileWidget, presentersWidget } from "cle/presenters_widgets"
import { courseDifficultyMobileWidget, courseDifficultyWidget } from "cle/course_difficulty_widgets"
import { courseTypeMobileWidget, courseTypeWidget } from "cle/course_type_widgets"
import { ratingMobileWidget, ratingWidget } from "cle/rating_widgets"

class WidgetsConfiguration {
  constructor(refinements, facets, showCounters, onMobile) {
    this.refinements = refinements
    this.facets = facets
    this.showCounters = showCounters
    this.onMobile = onMobile
  }

  addPracticeAreasWidget() {
    if (this.facets.practice_areas) {
      let widget
      if (this.onMobile) {
        widget = practiceAreasMobileWidget()
      } else {
        widget = practiceAreasWidget({ showCounters: this.showCounters })
      }
      this.refinements.push(widget)
    }
  }

  addCourseDifficultyWidget() {
    if (this.facets.course_difficulty) {
      let widget
      if (this.onMobile) {
        widget = courseDifficultyMobileWidget()
      } else {
        widget = courseDifficultyWidget({ showCounters: this.showCounters })
      }
      this.refinements.push(widget)
    }
  }

  addCourseTypeWidget() {
    if (this.facets.course_type) {
      let widget
      if (this.onMobile) {
        widget = courseTypeMobileWidget()
      } else {
        widget = courseTypeWidget({ showCounters: this.showCounters })
      }
      this.refinements.push(widget)
    }
  }

  addPresentersWidget() {
    if (this.facets.presenters) {
      this.refinements.push(this.onMobile ? presentersMobileWidget() : presentersWidget({ showCounters: this.showCounters }))
    }
  }

  addRatingWidget() {
    if (this.facets.rating) {
      this.refinements.push(this.onMobile ? ratingMobileWidget() : ratingWidget({ showCounters: this.showCounters}))
    }
  }

  addFilterChips() {
    this.refinements.push(
      instantsearch.widgets.currentRefinements({
        container: '#current_refinements', excludedAttributes: ['rounded_rating'],
        cssClasses: {
          list: "cle-current-refinements-list", label: "cle-current-refinements-label", item: "cle-current-refinements-item", category: "cle-current-refinements-category", categoryLabel: "cle-current-refinements-category-label"
        },
        transformItems(items) {
          return items.map((item) => {
            if (item.attribute !== 'presenters') {
              return item
            } else {
              return {
                ...item,
                refinements: item.refinements.map((ref) => { return { ...ref, label: ref.label.split("|").pop() }})
              }
            }
          })
        }
      })
    )
  }

  addClearRefinementsWidget() {
    this.refinements.push(
      instantsearch.widgets.clearRefinements({
        container: "#clear_refinements",
        cssClasses: {
          button: ["cle-clear-refinements-button"],
          disabledButton: ["hidden"]
        },
        templates: {
          resetLabel: "Clear filters"
        }
      })
    )
  }

  addJurisdictionsWidget(jurisdictionName) {
    if (this.facets.jurisdictions) {
      if (this.onMobile) {
        this.refinements.push(jurisdictionsMobileWidget({ jurisdictionName: jurisdictionName }))
      } else {
        this.refinements.push(jurisdictionsWidget({ jurisdictionName: jurisdictionName, showCounters: this.showCounters }))
      }
    }
  }

  addCreditTypesWidget(jurisdictionName) {
    if (this.facets.credit_types) {
      this.refinements.push(this.onMobile ? creditTypesMobileWidget() : creditTypesWidget({ showCounters: this.showCounters }))
    }
  }
}

export default WidgetsConfiguration
